import { Component } from '@angular/core';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';


@Component({
    selector: 'app-widget-empty',
    imports: [],
    templateUrl: './widget-empty.component.html',
    styleUrls: ['./widget-empty-base.component.scss']
})
export class WidgetEmptyBaseComponent extends WidgetBaseComponent { }
